import { render, staticRenderFns } from "./ForwardCurves.vue?vue&type=template&id=382c63ff&scoped=true"
import script from "./ForwardCurves.vue?vue&type=script&lang=js"
export * from "./ForwardCurves.vue?vue&type=script&lang=js"
import style0 from "./ForwardCurves.vue?vue&type=style&index=0&id=382c63ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c63ff",
  null
  
)

export default component.exports